<template>
  <div class="admin">
    
    <Nav>
      <template v-slot:logo-box>
        <Logo/>
      </template>
      <template v-slot:options-box>
        <DialoguesButton/>
      </template>
      <template v-slot:account-box>
        <AccountButton/>
      </template>
    </Nav>

    <GeneratorWrapper v-if="showGenerator" @close="showGenerator = false"/>
    <div class="body">
      <div class="limiter">
        <div class="main-box">

          <div class="navigator-box">
            <div :class="{'stats-title': true, 'active-stats': type == 'stats'}" @click="goStats">Stats</div>
            <div :class="{'logs-title': true, 'active-logs': type == 'logs'}" @click="goLogs">Logs</div>
          </div>

          <div class="stats-box" v-if="type == 'stats'">
            <div class="loading-box" v-if="loadingStats">
              <Loader color="white"/>
            </div>
            <div class="main-stats">
              <div class="data-row" v-for="stat in statsArray" :key="stat.title">
                <div class="title">{{ stat.title }}</div>
                <div class="value">{{ stat.value }}</div>
              </div>
            </div>
            <div class="user-stats" v-if="!loadingStats">
              <div class="menu">
                <div :class="{'last-week': true, 'active-left': activeUsers == 7}" @click="onActiveUsersChange(7)">
                  <span class="long">Users active in 7 days -- <b>({{ getWeekActitity }})</b></span>
                  <span class="short">7 days - <b>({{ getWeekActitity }})</b></span>
                </div>
                <div :class="{'last-month': true, 'active-right': activeUsers == 30}" @click="onActiveUsersChange(30)">
                  <span class="long">Users active in 30 days -- <b>({{ getMonthActitity }})</b></span>
                  <span class="short">30 days - <b>({{ getMonthActitity }})</b></span>
                </div>
              </div>
              <div class="week-list" v-if="activeUsers == 7">
                <UserRow v-for="user in users" :key="user._id" :data="user" @searchByUser="searchByUser"/>
              </div>
              <div class="month-list" v-if="activeUsers == 30">
                <UserRow v-for="user in users" :key="user._id" :data="user" @searchByUser="searchByUser"/>
              </div>
            </div>
          </div>

          <div class="logs-box" v-if="type == 'logs'">
            <div :class="{'search-box': true, 'hide': !controlBar}">

              <div class="control-bar">

                <div class="switch-button-box">
                  <div class="switch-button" @click="controlBar = !controlBar">
                    <font-awesome-icon :icon="['fas', 'sort-down']" class="icon down" v-if="!controlBar"/>
                    <font-awesome-icon :icon="['fas', 'sort-up']" class="icon up" v-if="controlBar"/>
                  </div>
                </div>

                <div class="refresh-button-box">
                  <div class="refresh-button" @click="loadLogs">
                    <font-awesome-icon :icon="['fas', 'sync-alt']" class="icon"/>
                  </div>
                </div>

              </div>

              <div :class="{'sort-box': true, 'hide-row': !controlBar}">
                <div class="label">Sorting: </div>
                <font-awesome-icon :icon="['fas', 'sort-alpha-up']" :class="{ 'icon': true, 'active': sorting == 'desc' }" @click="sorting = 'desc'"/>
                <font-awesome-icon :icon="['fas', 'sort-alpha-down']" :class="{ 'icon': true, 'active': sorting == 'asc' }" @click="sorting = 'asc'"/>
              </div>

              <div :class="{'select-box': true, 'hide-row': !controlBar}">
                <div class="label">Events: </div>

                <div class="event">
                  <label for="loadMain">LoadMain</label>
                  <input type="checkbox" name="loadMain" id="loadMain" v-model="checkboxes.loadMain">
                </div>

                <div class="event">
                  <label for="loadEdit">LoadEdit</label>
                  <input type="checkbox" name="loadEdit" id="loadEdit" v-model="checkboxes.loadEdit">
                </div>

                <div class="event">
                  <label for="loadPlay">LoadPlay</label>
                  <input type="checkbox" name="loadPlay" id="loadPlay" v-model="checkboxes.loadPlay">
                </div>

              </div>

              <div :class="{'user-box': true, 'hide-row': !controlBar}">
                <div class="label">User: </div>
                <input type="text" v-model="userInput">
              </div>

              <div :class="{'page-box': true, 'hide-row': !controlBar}">
                <div class="label">Page: </div>
                <div class="page-switch">
                  <div class="number-box">{{ page }}</div>
                  <div class="control-box">
                    <div class="up-box" @click="pageUp">
                      <font-awesome-icon :icon="['fas', 'sort-up']" class="icon"/>
                    </div>
                    <div class="down-box" @click="pageDown">
                      <font-awesome-icon :icon="['fas', 'sort-down']" class="icon"/>
                    </div>
                  </div>
                </div>
              </div>

              <div :class="{'date-box': true, 'hide-row': !controlBar}">
                <div class="date-from">
                  <label for="date-from">From: </label>
                  <input type="date" name="date-from" id="date-from" v-model="dateFrom">
                </div>
                <div class="date-to">
                  <label for="date-to">To: </label>
                  <input type="date" name="date-to" id="date-to" v-model="dateTo">
                </div>
              </div>

              <div class="button-box">
                <div class="search-button" @click="loadLogs">
                  <font-awesome-icon :icon="['fas', 'sync-alt']" class="icon"/>
                </div>
              </div>

            </div>
            <div class="loading-box" v-if="loadingLogs">
              <Loader color="white"/>
            </div>

            <div class="content-box">
              <LogRow v-for="log in logs" :key="log._id" :data="log" @searchByUser="searchByUser"/>
              <div class="span" v-if="logs.length == 0 && !loadingLogs">No Logs</div>
            </div>

          </div>

        </div>

        <PromoCodes :generatorState="showGenerator" @openGenerator="showGenerator = true"/>

      </div>
    </div>
  </div>
</template>

<script>
import alert from '@/lib/alert'
import axios from 'axios'
import LogRow from '../components/Admin/LogRow'
import UserRow from '../components/Admin/UserRow'
import PromoCodes from '../components/Admin/PromoCodes'
import GeneratorWrapper from '../components/Admin/GeneratorWrapper'
import Loader from '@/components/Loader'
//Nav
import Nav from '@/components/Nav/Nav'
import Logo from '@/components/Nav/Logo'
import DialoguesButton from '@/components/Nav/DialoguesButton'
import AccountButton from '@/components/Nav/AccountButton'

export default {
  name: 'Admin',
  data() {
    return {
      type: null,
      stats: [],
      logs: [],
      loadingStats: false,
      loadingLogs: false,
      checkboxes: {
        loadMain: true,
        loadEdit: true,
        loadPlay: true
      },
      sorting: 'desc',
      page: 1,
      userInput: null,
      dateFrom: null,
      dateTo: null,
      activeUsers: 7,
      users: [],
      controlBar: false,
      showGenerator: false,
      changelog: null
    }
  },
  components: {
    LogRow,
    UserRow,
    PromoCodes,
    GeneratorWrapper,
    Loader,
    //Nav
    Nav,
    Logo,
    DialoguesButton,
    AccountButton
  },
  methods: {
    goStats() {
      if(this.type != 'stats') {
        this.$router.push('/admin?type=stats&usersActivity=7');
        this.type = 'stats';
        this.loadStats();
        this.loadActiveUsers();
      }
    },
    goLogs() {
      if(this.type != 'logs') {
        this.type = 'logs';
        this.loadLogs();
      }
    },
    loadStats() {
      this.stats = [];
      this.loadingStats = true;
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}loadStats`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        }
      }).then(data => {
        this.stats = data.data.data;
        this.loadingStats = false;
      }).catch(err => {
        this.loadingStats = false;
        console.log(err);
      })
    },
    loadLogs() {
      this.$router.push(`/admin?type=logs&sort=${this.sorting}&loadMain=${this.checkboxes.loadMain}&loadEdit=${this.checkboxes.loadEdit}&loadPlay=${this.checkboxes.loadPlay}&dateFrom=${this.dateFrom}&dateTo=${this.dateTo}&page=${this.page}&user=${this.userInput}`).catch(err => {
        console.log(err.message);
      })
      this.logs = [];
      this.loadingLogs = true;

      let dateFrom = new Date(this.dateFrom);
      let dateTo = new Date(this.dateTo);

      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}loadLogs`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          loadMain: this.checkboxes.loadMain,
          loadEdit: this.checkboxes.loadEdit,
          loadPlay: this.checkboxes.loadPlay,
          page: this.page,
          sort: this.sorting,
          dateFrom: dateFrom.valueOf(),
          dateTo: dateTo.valueOf(),
          user: this.userInput
        }
      }).then(data => {
        this.logs = data.data.data;
        this.loadingLogs = false;
      }).catch(err => {
        this.loadingLogs = false;
        console.log(err);
      })
    },
    pageUp() {
      this.page += 1;
    },
    pageDown() {
      if(this.page != 1) {
        this.page -= 1;
      }
    },
    onActiveUsersChange(number) {
      if(this.activeUsers != number) {
        this.$router.push(`/admin?type=stats&usersActivity=${number}`);
        this.activeUsers = number;
        this.loadActiveUsers();
      }
    },
    loadActiveUsers() {
      this.users = [];
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}loadActiveUsers`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          period: parseInt(this.activeUsers)
        }
      }).then(data => {
        this.users = data.data.data;
      }).catch(err => {
        console.log(err);
      })
    },
    searchByUser(email) {
      this.userInput = email;
      this.page = 1;
      this.loadLogs();
      if(this.type == 'stats') {
        this.type = 'logs';
      }
    },
    loadChangelog() {
      axios({
        method: "POST",
        url: "https://graphql.datocms.com",
        headers: {
          Authorization: 'bearer ' + '390e8b3717f6f61e8e41e57b6f78e2'
        },
        data: {
          query: `
            {
              allChangelogs(first: "1") {
                date
                commitId
                description
                title
                changes {
                  text
                }
              }
            }
          `
        }
      }).then(result => {
        this.changelog = result.data.data.allChangelogs[0];
        console.log('%cFrogero Changelog', 'font-size: 0.8rem; color: grey;')
        console.log('')
        console.log('%cName:', 'font-size: 0.8rem; color: grey')
        console.log(`%c${this.changelog.title}`, 'font-weight: bold; font-size: 0.85rem; color: #11b6a6')

        if(this.changelog.description != '') {
          console.log('')
          console.log('%cDescription:', 'font-size: 0.8rem; color: grey')
          console.log(`%c${this.changelog.description}`, 'font-weight: bold; font-size: 0.8rem;')
        }

        if(this.changelog.changes.length > 0) {
          console.log('')
          console.log('%cChanges:', 'font-size: 0.8rem; color: grey')
          this.changelog.changes.forEach(change => {
            console.log(`%c- ${change.text}`, 'font-weight: bold; font-size: 0.8rem;')
          });
        }

        if(this.changelog.commitId != '') {
          console.log('')
          console.log('%cCommit Id:', 'font-size: 0.8rem; color: grey')
          console.log(`%c${this.changelog.commitId}`, 'font-weight: bold; font-size: 0.8rem; color: #ffd166')
        }

        console.log('')
        console.log('%cDate:', 'font-size: 0.8rem; color: grey')
        console.log(`%c${this.changelog.date}`, 'font-weight: bold; font-size: 0.8rem; color: #ef476f')

        console.log('')
      }).catch(err => {
        console.log(err);
        console.log('Error during loading changelogs');
      });
    }
  },
  computed: {
    statsArray() {
      let array = this.stats.filter(stat => {
        return stat.type == 'array';
      });
      return array;
    },
    getWeekActitity() {
      return this.stats.find(stat => {
        return stat.title == 'week';
      }).value;
    },
    getMonthActitity() {
      return this.stats.find(stat => {
        return stat.title == 'month';
      }).value;
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.type = urlParams.get('type');
    if(this.type == 'stats') {
      let usersActivity = urlParams.get('usersActivity');
      if(usersActivity) {
        this.activeUsers = usersActivity;
      }
      this.loadStats();
      this.loadActiveUsers();
    } else {
      let sort = urlParams.get('sort');
      let loadMain = urlParams.get('loadMain');
      let loadEdit = urlParams.get('loadEdit');
      let loadPlay = urlParams.get('loadPlay');
      let dateFrom = urlParams.get('dateFrom');
      let dateTo = urlParams.get('dateTo');
      let page = urlParams.get('page');
      let user = urlParams.get('user');

      if(sort) {
        this.sorting = sort;
      }
      if(loadMain) {
        if(loadMain == 'true') {
          this.checkboxes.loadMain = true;
        } else {
          this.checkboxes.loadMain = false;
        }
      }
      if(loadEdit) {
        if(loadEdit == 'true') {
          this.checkboxes.loadEdit = true;
        } else {
          this.checkboxes.loadEdit = false;
        }
      }
      if(loadPlay) {
        if(loadPlay == 'true') {
          this.checkboxes.loadPlay = true;
        } else {
          this.checkboxes.loadPlay = false;
        }
      }
      if(dateFrom) {
        this.dateFrom = dateFrom;
      }
      if(dateTo) {
        this.dateTo = dateTo;
      }
      if(page) {
        if(parseInt(page)) {
          this.page = parseInt(page);
        }
      }
      if(user) {
        if(user != 'null') {
          this.userInput = user;
        }
      }
      this.loadLogs();
    }
    setTimeout(() => {
      this.loadChangelog();
    }, 3000);
  },
  beforeRouteEnter(to, from, next) {
    axios({
      method: 'post',
      url: `${process.env.VUE_APP_SERVER_URL}checkAdmin`,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') 
      },
    }).then(() => {
      if(!to.query.type) {
        next('/admin?type=stats&usersActivity=7');
      }else {
        next();
      }
    }).catch(() => {
      alert.showError('Unathorized');
      next('/main');
    })
  },
}
</script>

<style lang="scss" scoped>
.admin {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

.body {
  width: 100%;
  min-height: calc(100vh - 5rem);
  background-color: white;
  display: flex;
  justify-content: center;

  .limiter {
    width: 70rem;
    height: 100%;
    display: flex;
    flex-direction: column;

    @media (max-width: 1200px) {
      width: 90%;
    }
  }
}

.main-box {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 4rem;
  margin-bottom: 4rem;
}

.navigator-box {
  width: 100%;
  height: 4rem;
  display: flex;
  background-color: #11b6a6af;
  border-top-right-radius: 0.3rem;
  border-top-left-radius: 0.3rem;

  @media (max-width: 900px) {
    height: 4rem;
  }

  .stats-title {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    color: white;
    transition: 0.2s;

    @media (max-width: 900px) {
      font-size: 1.3rem;
    }

    &:hover {
      cursor: pointer;
      background-color: #11b6a6af;
    }
  }

  .logs-title {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    color: white;
    transition: 0.2s;

    @media (max-width: 900px) {
      font-size: 1.3rem;
    }

    &:hover {
      cursor: pointer;
      background-color: #11b6a6af;
    }
  }

  .active-stats {
    -webkit-box-shadow: inset -10px 10px 30px -21px rgba(0,0,0,0.75);
    -moz-box-shadow: inset -10px 10px 30px -21px rgba(0,0,0,0.75);
    box-shadow: inset -10px 10px 30px -21px rgba(0,0,0,0.75);
    &:hover {
      cursor: default;
      background-color: unset;
    }
  }

  .active-logs {
    -webkit-box-shadow: inset 10px 10px 30px -21px rgba(0,0,0,0.75);
    -moz-box-shadow: inset 10px 10px 30px -21px rgba(0,0,0,0.75);
    box-shadow: inset 10px 10px 30px -21px rgba(0,0,0,0.75);
    &:hover {
      cursor: default;
      background-color: unset;
    }
  }
}

.stats-box {
  width: 100%;
  min-height: 20rem;
  background-color: rgb(224, 224, 224);
  border-bottom-right-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  .loading-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .main-stats {
    width: 100%;
    height: 5rem;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin-top: 1rem;
    @media (max-width: 1000px) {
      width: 90%;
    }
    @media (max-width: 900px) {
      justify-content: space-between;
    }
    @media (max-width: 800px) {
      flex-direction: column;
      justify-content: space-evenly;
      height: 12rem;
    }
  }

  .data-row {
    width: 18rem;
    height: 3rem;
    display: flex;
    background-color: white;
    border-radius: 0.3rem;
    @media (max-width: 1000px) {
      width: 15rem;
    }
    @media (max-width: 900px) {
      width: 13rem;
    }
    @media (max-width: 800px) {
      width: 100%;
    }

    .title {
      width: 60%;
      height: 100%;
      display: flex;
      align-items: center;
      padding-left: 1rem;
      font-weight: bold;
      color: rgb(124, 124, 124);
    }

    .value {
      width: 40%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      color: rgb(124, 124, 124);
    }
  }

  .user-stats {
    width: 90%;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-top: 3rem;
    margin-bottom: 2rem;
    border-radius: 0.3rem;
    overflow: hidden;

    .menu {
      width: 100%;
      height: 4rem;
      display: flex;
      background-color: white;
      color: rgb(124, 124, 124);
      border-bottom: 2px solid rgb(214, 214, 214);

      .last-week {
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-right: 1px solid rgb(214, 214, 214);

        .long {
          @media (max-width: 700px) {
            display: none;
          }
        }

        .short {
          display: none;
          @media (max-width: 700px) {
            display: flex;
            color: black;
          }
        }
      }
      .last-month {
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-left: 1px solid rgb(214, 214, 214);

        .long {
          @media (max-width: 700px) {
            display: none;
          }
        }

        .short {
          display: none;
          @media (max-width: 700px) {
            display: flex;
            color: black;
          }
        }
      }

      .active-left {
        -webkit-box-shadow: inset -10px 10px 30px -21px rgba(0,0,0,0.75);
        -moz-box-shadow: inset -10px 10px 30px -21px rgba(0,0,0,0.75);
        box-shadow: inset -10px 10px 30px -21px rgba(0,0,0,0.75);
        &:hover {
          cursor: default;
        }
      }

      .active-right {
        -webkit-box-shadow: inset 10px 10px 30px -21px rgba(0,0,0,0.75);
        -moz-box-shadow: inset 10px 10px 30px -21px rgba(0,0,0,0.75);
        box-shadow: inset 10px 10px 30px -21px rgba(0,0,0,0.75);
        &:hover {
          cursor: default;
        }
      }

    }

    .week-list {
      width: 100%;
      min-height: 4rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: white;
      padding-top: 1rem;
    }

    .month-list {
      width: 100%;
      min-height: 4rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: white;
      padding-top: 1rem;
    }

  }
}

.logs-box {
  width: 100%;
  min-height: 20rem;
  background-color: rgb(224, 224, 224);
  border-bottom-right-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  .loading-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .search-box {
    width: 100%;
    height: 4rem;
    margin-bottom: 1rem;
    background-color: rgb(238, 238, 238);
    border-radius: 0.3rem;
    display: flex;

    @media (max-width: 1000px) {
      height: 17.5rem;
      flex-direction: column;
    }

    .control-bar {
      flex: 1;
      height: 100%;
      display: none;
      border-bottom: 3px solid rgb(214, 214, 214);

      .switch-button-box {
        width: 4rem;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .switch-button {
          width: 2.3rem;
          height: 2.3rem;
          border-radius: 0.2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgb(207, 207, 207);
          color: rgb(58, 58, 58);
          transition: 0.2s;

          .up {
            font-size: 1.5rem;
            margin-top: 0.6rem;
          }

          .down {
            font-size: 1.5rem;
            margin-bottom: 0.4rem;
          }

          &:hover {
            filter: brightness(0.95);
            cursor: pointer;
          }

          &:active {
            transform: scale(0.9);
          }
        }
      }

      .refresh-button-box {
        width: 4rem;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: auto;

        .refresh-button {
          width: 2.3rem;
          height: 2.3rem;
          border-radius: 0.2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #11b6a6;
          color: rgb(224, 224, 224);
          transition: 0.2s;

          &:hover {
            filter: brightness(0.95);
            cursor: pointer;
          }

          &:active {
            transform: scale(0.9);
          }
        }
      }

      @media (max-width: 1000px) {
        display: flex;
      }
    }

    .sort-box {
      flex: 0.6;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      border-right: 2px dashed rgb(214, 214, 214);
      user-select: none;

      @media (max-width: 1000px) {
        flex: 1;
        border-right: unset;
        border-bottom: 2px solid rgb(214, 214, 214);
        justify-content: flex-start;

        .label {
          display: flex;
          margin-left: 2rem;
        }

        .icon {
          margin-left: 2rem;
        }
      }

      .label {
        font-weight: bold;
        display: none;
      }

      .icon {
        font-size: 1.2rem;

        &:hover {
          cursor: pointer;
        }
      }

      .active {
        color: #11b6a6;
      }
    }

    .select-box {
      flex: 2;
      height: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      border-right: 2px dashed rgb(214, 214, 214);
      user-select: none;

      @media (max-width: 1000px) {
        flex: 1;
        border-right: unset;
        border-bottom: 2px solid rgb(214, 214, 214);
        justify-content: start;

        .label {
          display: flex !important;
          margin-left: 2rem;
        }

        .event {
          margin-left: 2rem;
        }
      }

      @media (max-width: 500px) {
        justify-content: space-evenly;
        .label {
          display: none !important;
        }
        .event {
          margin-left: unset;
        }
      }

      .label {
        font-weight: bold;
        display: none;
      }

      .event {
        user-select: none;
        label {
          cursor: pointer;
        }
        input {
          margin-left: 0.5rem;
          cursor: pointer;
        }
      }
      
    }

    .user-box {
      flex: 1.3;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      border-right: 2px dashed rgb(214, 214, 214);
      user-select: none;

      @media (max-width: 1000px) {
        flex: 1;
        border-right: unset;
        border-bottom: 2px solid rgb(214, 214, 214);
        justify-content: flex-start;

        .label {
          margin-left: 2rem;
        }

        input {
          margin-left: 2.8rem;
          margin-right: 2rem;
          flex: 1;
        }
      }

      .label {
        font-weight: bold;
      }

      input {
        width: 9rem;
        height: 2rem;
        background-color: rgb(224, 224, 224);
        border: none;
        border-radius: 0.2rem;
        outline: none;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
    }

    .page-box {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      border-right: 2px dashed rgb(214, 214, 214);

      @media (max-width: 1000px) {
        flex: 1;
        border-right: unset;
        border-bottom: 2px solid rgb(214, 214, 214);
        justify-content: flex-start;

        .label {
          margin-left: 2rem;
        }

        .page-switch {
          margin-left: 2.8rem;
        }
      }

      .label {
        font-weight: bold;
      }

      .page-switch {
        width: 4rem;
        height: 2.5rem;
        display: flex;
        border-radius: 0.2rem;
        overflow: hidden;
        user-select: none;

        .number-box {
          width: 2.5rem;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgb(224, 224, 224);
        }

        .control-box {
          width: 1.5rem;
          height: 100%;
          display: flex;
          flex-direction: column;

          .up-box {
            width: 100%;
            height: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #11b6a6;
            border-bottom: 1px solid rgb(224, 224, 224);
            color: rgb(224, 224, 224);
            transition: 0.2s;

            &:hover {
              filter: brightness(0.95);
              cursor: pointer;
            }

            .icon {
              margin-top: 0.5rem;
            }
          }

          .down-box {
            width: 100%;
            height: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #11b6a6;
            border-top: 1px solid rgb(224, 224, 224);
            color: rgb(224, 224, 224);
            transition: 0.2s;

            &:hover {
              filter: brightness(0.95);
              cursor: pointer;
            }

            .icon {
              margin-bottom: 0.5rem;
            }
          }
        }
      }
    }

    .date-box {
      flex: 1.3;
      height: 100%;
      display: flex;
      border-right: 2px dashed rgb(214, 214, 214);

      @media (max-width: 1000px) {
        flex: 1;
        border-right: unset;
      }

      .date-from {
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;

        @media (max-width: 1000px) {
          justify-content: flex-start;
          width: auto;

          label {
            margin-left: 2rem;
          }

          input {
            margin-left: 2.7rem;
          }
        }

        @media (max-width: 400px) {
          justify-content: space-evenly;
          width: 50%;

          label {
            margin-left: unset
          }

          input {
            margin-left: unset;
          }
        }

        label {
          font-weight: bold;
        }

        input {
          width: 2.3rem;
          height: 2.3rem;
          border: 2px solid #11b6a6;
          border-radius: 0.2rem;
          padding: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          &::-webkit-datetime-edit {
            display: none;
          }
          &::-webkit-calendar-picker-indicator {
            width: 100%;
            padding: auto;
            margin: 0;
            font-size: 1.2rem;
          }
        }
      }

      .date-to {
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;

        @media (max-width: 1000px) {
          justify-content: flex-start;
          width: auto;
          margin-left: 2rem;

          label {
            margin-left: 2rem;
          }

          input {
            margin-left: 2.7rem;
          }
        }

        @media (max-width: 400px) {
          justify-content: space-evenly;
          width: 50%;

          label {
            margin-left: unset
          }

          input {
            margin-left: unset;
          }
        }

        label {
          font-weight: bold;
        }

        input {
          width: 2.3rem;
          height: 2.3rem;
          border: 2px solid #11b6a6;
          border-radius: 0.2rem;
          padding: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          &::-webkit-datetime-edit {
            display: none;
          }
          &::-webkit-calendar-picker-indicator {
            width: 100%;
            padding: auto;
            margin: 0;
            font-size: 1.2rem;
          }
        }
      }
    }

    .button-box {
      flex: 0.5;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      @media (max-width: 1000px) {
        display: none;
      }

      .search-button {
        width: 2.3rem;
        height: 2.3rem;
        border-radius: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #11b6a6;
        color: rgb(224, 224, 224);
        transition: 0.2s;

        &:hover {
          filter: brightness(0.95);
          cursor: pointer;
        }

        &:active {
          transform: scale(0.9);
        }
      }
    }

    @media (max-width: 1000px) {
      .hide-row {
        display: none
      }
    }
  }

  @media (max-width: 1000px) {
    .hide {
      width: 100%;
      height: 3.5rem;
    }
  }

  .content-box {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}
</style>